import $ from 'jquery';
import 'bootstrap';
import './utils/callback';
import './utils/animation';
import './utils/mortgage-modals-auto';
import './utils/hero-video';
import './utils/home-hero-videos';
import Inputmask from 'inputmask';
import { Modal } from 'bootstrap';

window.$ = $;
window.jQuery = $;
window.Modal = Modal;

$(function () {
    const mask = new Inputmask('+7 (999) 999-99-99');
    mask.mask(document.querySelectorAll('.maskedinput-phone'));

    let url = window.location.pathname;
    url = url.split('/');
    url = '/' + url[1];
    $('.nav-item a[href="' + url + '"]').addClass('active');

    $(window).scroll(function () {
        if ($(this).scrollTop() > 200) {
            $('.scrollup').removeClass('d-none');
            $('.float-actions').addClass('is-scrolled');
        } else {
            $('.scrollup').addClass('d-none');
            $('.float-actions').removeClass('is-scrolled');
        }
    });

    $('.scrollup').click(function () {
        $('html, body').animate({ scrollTop: 0 }, 600);
        return false;
    });

    $(document).on('click', 'a[data-scroll^="#"]', function (event) {
        event.preventDefault();
        $('html, body').animate({
            scrollTop: ($($.attr(this, 'data-scroll')).offset().top - 100)
        }, 700);
    });

    if (document.querySelector('input[type=file]')) {
        document.querySelectorAll('input[type=file]').forEach(function (input) {
            input.addEventListener('change', function () {
                let profilePicValue = input.value;
                let fileNameStart = profilePicValue.lastIndexOf('\\');
                profilePicValue = profilePicValue.substr(fileNameStart + 1);
                let profilePicLabelText = input.nextElementSibling;

                if (profilePicValue !== '') {
                    profilePicLabelText.innerHTML = 'Выбрать другой';
                    profilePicLabelText.classList.add('active');
                } else {
                    profilePicLabelText.innerHTML = 'Прикрепить файл';
                    profilePicLabelText.classList.remove('active');
                }
            });
        });
    }

    if (document.querySelector('.to-top')) {
        const toTop = document.querySelector('.to-top');

        window.onscroll = function () {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                toTop.classList.add('show');
            } else {
                toTop.classList.remove('show');
            }
        };

        toTop.addEventListener('click', function () {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        });
    }

    $('[data-bs-toggle="tooltip"]').tooltip({
        template: '<div class="tooltip blue-tooltip" role="tooltip">' +
            '<div class="tooltip-inner"></div></div>'
    });
});

function onEntry(entry) {
    entry.forEach((change) => {
        if (change.isIntersecting) {
            change.target.classList.add('element-show');
        }
    });
}

if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(onEntry, { threshold: [0.3] });
    document.querySelectorAll('.element-animation').forEach((elm) => observer.observe(elm));
}

document.addEventListener('DOMContentLoaded', function () {
    const fixedBtn = document.querySelector('.app-fixed-btn');
    const fixedMenu = document.querySelector('.fixed-menu');
    if (!fixedBtn || !fixedMenu) {
        return;
    }

    fixedBtn.addEventListener('click', function (event) {
        event.preventDefault();
        fixedMenu.classList.add('active');
        fixedBtn.classList.add('hide');
    });

    document.addEventListener('click', function (event) {
        if (!fixedMenu.contains(event.target) && !fixedBtn.contains(event.target)) {
            fixedMenu.classList.remove('active');
            fixedBtn.classList.remove('hide');
        }
    });
});

$(document).ready(function () {
    const fixedMenu = $('.fixed-menu');
    if (!fixedMenu.length) {
        return;
    }
    let lastScrollTop = 0;

    $(window).scroll(function () {
        const currentScrollTop = $(this).scrollTop();
        if (currentScrollTop > lastScrollTop) {
            if (currentScrollTop >= 500) {
                fixedMenu.removeClass('active');
            }
        } else if (currentScrollTop <= 500) {
            fixedMenu.addClass('active');
        }
        lastScrollTop = currentScrollTop;
    });
});

$(document).ready(function () {
    $('.app-blog-text').each(function () {
        const maxTextLength = 230;
        const text = $(this).text();
        if (text.length > maxTextLength) {
            $(this).text(text.slice(0, maxTextLength) + '...');
        }
    });
});

$('.app-number-order').each(function () {
    const numberText = $(this).text();
    const numberWithoutSpaces = numberText.replace(/\s/g, '');
    const numberWithSpaces = numberWithoutSpaces.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    $(this).text(numberWithSpaces);
});

$(document).on('click', '.contacts-map-blocker', function () {
    $(this).closest('.contacts-map-shell').addClass('is-active');
});
